import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const propTypes = {
  rows: PropTypes.array,
  cells: PropTypes.array,
  cssClass: PropTypes.string,
};

const Table = ({ rows, cells, cssClass }) => {
  const tableClasses = cx({
    table: true,
    [cssClass]: true,
  });

  return (
    <table className={tableClasses}>
      <tbody>
        {rows.map((item) => (
          <tr key={item.id}>
            {cells.map((col) => (
              <td key={`${item.id}-${col}`}>
                {item[col]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

Table.propTypes = propTypes;

export default Table;
